var lists_default = {
  "fontElementMap": "IWRE-",
  "orderedlist": "IbU50",
  "bulletedlist": "Otwiv",
  "listItem": "RhWEo"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
